import to from './to'
/* 
    触发全局验证码
    返回触发校验完成参数
*/
export default () => {
    return to(new Promise((resolve, reject) => {
        (window as any).useCaptcha.reload();
        (window as any).useCaptcha.on('verifySuccess', function (security_code: string) {
            resolve(security_code)
        });
        (window as any).useCaptcha.on('verifyFail', function (error: any) {
            reject(error)
        });
        (window as any).useCaptcha.show();
    }))
}